import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Sun } from "lucide-react";
 * // Use <Sun /> instead
 */
export const LightModeIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M13 1v3.5a1 1 0 1 1-2 0V1h2ZM17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0ZM4.5 11H1v2h3.5a1 1 0 1 0 0-2ZM3.515 19.071l2.475-2.475a1 1 0 0 1 1.414 1.414l-2.475 2.475-1.414-1.414ZM7.404 5.99 4.929 3.515 3.515 4.929 5.99 7.404A1 1 0 0 0 7.404 5.99ZM13 23v-3.5a1 1 0 1 0-2 0V23h2ZM19.5 11H23v2h-3.5a1 1 0 1 1 0-2ZM19.071 3.515 16.596 5.99a1 1 0 0 0 1.414 1.414l2.475-2.475-1.414-1.414ZM18.01 16.596l2.475 2.475-1.414 1.414-2.475-2.475a1 1 0 0 1 1.414-1.414Z"
  />
);
